import React from 'react';
import { Link } from 'react-router-dom';

const Register: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            注册已关闭
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            请前往{' '}
            <Link
              to="/login"
              className="font-medium text-primary-600 hover:text-primary-500"
            >
              登录页面
            </Link>
          </p>
        </div>
        <div className="mt-8">
          <div className="bg-yellow-50 border border-yellow-200 text-yellow-700 px-4 py-3 rounded text-center">
            当前站点不开放自助注册。请联系管理员为您开通账号。
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
